<div class="container-fluid h-100 readOnlyForm pl-0 pr-0">


  <!-- Section header start -->
  <div class="headerBackground card p-1 mb-2 tool-header-height">
    <div class="row padding2px">
      <div class="col col-1 col-md-1 col-lg-1 col-sm-1 col-xs-1 sectionHeaderIcon">
        <span>
          <!-- <fa-icon class="fas checklistIcon" title="click for smart checklist" (click)="openSmartChecklist()"  [icon]="faCircle">
          </fa-icon> -->
          <fa-icon class="far fa-lg autoCursor" title="click for smart checklist" (click)="openSmartChecklist()"
            [icon]="faObjectGroup"></fa-icon>
        </span>
      </div>
      <div class="col col-3 col-md-3 col-lg-3 col-sm-3 col-xs-4 cursorArrow">
        <h6 class="headerFontSize">{{ 'menu.environmentMapper' | translate }}</h6>
      </div>
      <div class="col col-6 col-md-6 col-lg-6 col-sm-6 col-xs-6 cursorArrow">
        <p class="titleParagraph">
          {{'environmentDesigner.toolHeaderLine1' | translate}}<br>
          {{'environmentDesigner.toolHeaderLine2' | translate}}
        </p>
      </div>
      <div class="col col-2 col-md-2 col-lg-2 col-sm-2 col-xs-2">
        <table class="dropGroupBtn">
          <tr>
            <td rowspan="2">
              <span>
                <a type="button" (click)="openChatGPTassist()">
                  <fa-icon class="fas fa-lg toolLogoYellow" [icon]="faLightbulb" title="intelligent assistant"></fa-icon>
                </a>
              </span>
            </td>
            <td rowspan="2">
              <span>
                <a id="environmentYoutube" type="button" class="cursorPointer" data-toggle="modal"
                  data-target="#ytVideoLinkEM">
                  <fa-icon class="fas fa-lg" [icon]="faInfoCircle" title="help"></fa-icon>
                </a>
              </span>
            </td>
            <td rowspan="2">
              <span (click)="envMap.length > 0 && generateReport('true')">
                <fa-icon class="fas fa-lg cursorPointer" [icon]="faFileExport" title="report"></fa-icon>
              </span>
            </td>
            <td rowspan="2">
              <span class="autoCursor ">
                <fa-icon class="fas fa-lg extraIcon cursorPointer" [icon]="faFileExport" title="report"></fa-icon>
              </span>
            </td>
          </tr>
        </table>
        <!-- <div class="dropGroupBtn marginbottom5px">
          <span>
            <a id="environmentYoutube" type="button" class="" data-toggle="modal" data-target="#ytVideoLinkEM">
              <fa-icon class="fas" [icon]="faInfoCircle" title="help"></fa-icon>
            </a>
          </span>
        </div>
        <div class="dropGroupBtn marginbottom5px">
          <span (click)="envMap.length > 0 && generateReport('true')">
            <fa-icon class="fas" [icon]="faFileExport" title="report"></fa-icon>
          </span>
        </div> -->
      </div>
    </div>
  </div>
  <!-- Section header end -->

  <div class="environ-designer tool-body-height">
    <div class="card p-1 mb-2 bg-black h-100">
      <div class="row full-width h-35 card p-0 bg-white">
        <div class="row strict h-100">
          <div class="row full-width p-0">
            <div class="col-xs-9 btn-padding pl-0">
              <div *ngIf="!showText" class="dropdown">
                <button [ngClass]="{ dis:envMap.length<=0}"
                  class="btn btn-default btn-sm btn-block dropdown-toggle paddingtop3px paddingbottom3px" type="button"
                  data-toggle="dropdown">
                  <div class="row strict">
                    <div class="col-xs-10 span-on-button ">
                      <span *ngIf="envMap.length>0">
                        {{selectedEnvironment.envName|| 'environmentDesigner.chooseEnvHeading' | translate }}
                      </span>
                      <span *ngIf="envMap.length<=0">
                        {{ 'environmentDesigner.addEnvHeading' | translate }}
                      </span>
                    </div>
                    <div class="col-xs-1 col-xs-offset-1 pull-right ">
                      <span class="caret"></span>
                    </div>
                  </div>
                </button>
                <ul class="dropdown-menu">
                  <li (click)="chooseEnvironment(false,false,en)" *ngFor="let en of envMap; let tabIndex = index">
                    <a>{{en.envName}}</a>
                  </li>
                </ul>
              </div>
              <div *ngIf="showText">
                <input id="envInputField" type="text"
                  (keyup.enter)="saveEnvironment(environmentName,oldEnvName, updateEnvname)"
                  [placeholder]="'environmentDesigner.envNamePlaceholder'| translate" [(ngModel)]="environmentName"
                  class="form-control strict xs-input environment-inputfield pl-3 pr-3">
              </div>
            </div>
            <div class="col-xs-2 btn-padding pr-0">
              <div class="row strict">
                <div class="col-xs-3 col-xs-offset-1 col-sm-3 col-sm-offset-1">
                  <div>
                    <button type="button" [ngClass]="{ dis:showText==true}" (click)="chooseEnvironment(true,true,'')"
                      class="btn btn-default btn-block btn-sm paddingtop3px paddingbottom3px mapperReadOnly">
                      <fa-icon class="fa menuItemsClrBlack" [icon]="faPlus"></fa-icon>
                    </button>
                  </div>
                </div>
                <div class="col-xs-3 col-xs-offset-1 col-sm-3 col-sm-offset-1">
                  <div>
                    <button type="button" (click)="editEnvironment(selectedEnvironment.envName)"
                      [ngClass]="{ dis:showText==true||new==true}"
                      class="btn btn-default btn-block btn-sm paddingtop3px paddingbottom3px mapperReadOnly">
                      <fa-icon class="fa menuItemsClrBlack" [icon]="faEdit"></fa-icon>
                    </button>
                  </div>
                </div>
                <div class="col-xs-3 col-xs-offset-1 col-sm-3 col-sm-offset-1">
                  <div *ngIf="!showText">
                    <button type="button" data-toggle="modal" data-target="#envDeleteConfirmModel"
                      [ngClass]="{ dis:selectedEnvironment.envName==undefined }"
                      class="btn btn-default btn-block btn-sm paddingtop3px paddingbottom3px mapperReadOnly">
                      <fa-icon class="fa menuItemsClrBlack" [icon]="faTrash"></fa-icon>
                    </button>
                  </div>
                  <div *ngIf="showText">
                    <button type="button" (click)="clear()"
                      class="btn btn-default btn-block btn-sm paddingtop3px paddingbottom3px mapperReadOnly">
                      <fa-icon class="fa menuItemsClrBlack" [icon]="faTimes"></fa-icon>
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="row strict env-table environment-choose-table-height">
            <ul class="alert-height list-group h-100 mb-0" *ngIf="listOfEnv.length<=0" class="list-group">
              <div class="alert alert-warning mb-0 cursorArrow">
                <strong>
                  <div style="text-align: center;">
                    {{ 'environmentDesigner.noEnvError' | translate }}
                  </div>
                </strong>
              </div>
            </ul>
            <div class="col-xs-12" *ngIf="listOfEnv.length>0">
              <table class="table table-bordered ui-sort-table table-xs h-100 mb-0">
                <thead class="" ui-sortable>
                  <tr class="ui-sortable-item row strict">
                    <td class="col-xs-1"></td>
                    <td class="col-xs-3 cursorArrow">Elements</td>
                    <td class="col-xs-8 cursorArrow">Values</td>
                  </tr>
                </thead>
                <tbody class="toolEntityTBody" ui-sortable [(ngModel)]="listOfEnv">
                  <tr class="ui-sortable-item row strict" *ngFor="let en of listOfEnv; let tabIndex = index"
                    auto-crud="true" on-create="add('', tabIndex)" on-delete="delete(tabIndex)">
                    <td class="col-xs-1"
                      [ngClass]="{dis:selectedEnvironment.envName==undefined||selectedEnvironment.envName==''||showText}">
                      <div style="text-align: center;">
                        <input class="cursorPointer" [checked]="isChecked(en)"
                          (click)="addForGeneration($event.target.checked,listOfEnv.indexOf(en),en)" type="checkbox">
                      </div>
                    </td>
                    <td class="col-xs-3">
                      <!-- <label auto-crud-source-readonly class="form-control transparent ellipsis"
												[textContent]="listOfEnv[tabIndex].envType"></label> -->
                      <textarea auto-crud-source class="form-control transparent cursorArrow" rows="1" autosize="true"
                        [(ngModel)]="listOfEnv[tabIndex].envType"
                        (blur)="onFocusOutEnv(listOfEnv[tabIndex].envType,tabIndex)">
                      </textarea>
                    </td>
                    <td class="col-xs-8">
                      <textarea auto-crud-source class="form-control transparent cursorArrow" rows="1" autosize="true"
                        (blur)="onFocusOutEnv(listOfEnv[tabIndex].envType,tabIndex)"
                        [(ngModel)]="listOfEnv[tabIndex].envValues" required>
                      </textarea>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
      <!-- <div class="full-width h-2"></div> -->
      <div class="row h-65 pl-0 pr-0">
        <div class="row strict p-1">
          <div *ngIf="selectedEnvironment.envName&&!showText" class="col-xs-12 menuItemsClrWhite cursorArrow">
            {{selectedEnvironment.envName||'environment name'}}
          </div>
        </div>
        <div class="row strict environment-combo-list-table-height table-bordered card ">
          <div class="col-xs-12">
            <button *ngIf="selectedEnvironment.envList.length<=0" [ngClass]="{dis:selectedEnvironment.envName==''}"
              class="btn btn-default btn-xs btn-block add-new-block-button mapperReadOnly" (click)="addEnvCombo()">
              <fa-icon class="fa icon menuItemsClrBlack" [icon]="faPlus"></fa-icon>
              <label>{{ 'environmentDesigner.emptyEnvCombinationButton' | translate }}</label>
            </button>
            <div class="h-100" ui-sortable>
              <div class="ui-sortable-item row padding-vertical"
                *ngFor="let envMap of selectedEnvironment.envList; let tabIndex = index" auto-crud="true"
                on-create="addEnVal('', tabIndex)" on-delete="deleteEnVal(tabIndex)">
                <div class="col-xs-1">
                  <label class="form-control transparent ellipsis">
                    <div style="text-align: center;">
                      {{selectEnvSubstr}}V 1.{{ tabIndex + 1 }}
                    </div>
                  </label>
                </div>
                <div class="col-xs-11">
                  <label auto-crud-source-readonly
                    class="form-control transparent ellipsis labelReadOnly mapperReadOnly"
                    [textContent]="selectedEnvironment.envList[tabIndex]"></label>
                  <!-- <textarea auto-crud-source class="form-control transparent mapperReadOnly" rows="1" autosize="true"
                    [(ngModel)]="selectedEnvironment.envList[tabIndex]" 
                    (blur)="onFocusOut(selectedEnvironment.envList[tabIndex],tabIndex)">
                  </textarea> -->
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- Section footer start -->
  <div class="headerBackground card p-1 mt-2 tool-footer-height">
    <div class='row pb-0 pt-0'>
      <div id="envmapperTip" class="carousel slide" data-ride="carousel" data-interval="false">
        <!-- Wrapper for slides -->
        <div class="carousel-inner text-color-yellow">
          <div class="row item active text-color-yellow">
            <div class="col-xs-12 align_center carousel-tip-align cursorArrow">
              Tip #1 : {{'environmentDesigner.tip1' | translate}}
            </div>
          </div>
          <div class="row item">
            <div class="col-xs-12 align_center carousel-tip-align cursorArrow">
              Tip #2 : {{'environmentDesigner.tip2' | translate}}
            </div>
          </div>
          <div class="row item">
            <div class="col-xs-12 align_center carousel-tip-align cursorArrow">
              Tip #3 : {{'environmentDesigner.tip3' | translate}}
            </div>
          </div>
        </div>
        <!-- Left and right controls -->
        <a class="left carousel-control carousel-tip-align display-flex" data-target="#envmapperTip" data-slide="prev">
          <span>
            <fa-icon class="fas" [icon]="faChevronLeft"></fa-icon>
          </span>
          <span class="sr-only">Previous</span>
        </a>
        <a class="right carousel-control carousel-tip-align display-flex" data-target="#envmapperTip" data-slide="next">
          <span>
            <fa-icon class="fas" [icon]="faChevronRight"></fa-icon>
          </span>
          <span class="sr-only">Next</span>
        </a>
      </div>
    </div>
  </div>
  <!-- Section footer end -->
  <!-- Youtube video Modal -->
  <div class="modal fade bd-example-modal-lg" id="ytVideoLinkEM" tabindex="-1" role="dialog"
    aria-labelledby="ytVideoLinkEM" aria-hidden="true">
    <div class="vertical-alignment-helper">
      <div class="modal-dialog vertical-align-center">
        <div class="modal-content ytVideoLink">
          <div class="modal-header">
            <button type="button" class="close" data-dismiss="modal" (click)="terminateVideo()"
              aria-hidden="true">&times;</button>
            <h4 class="modal-title cursorArrow" id="myModalLabel">{{'youtubeVideoTitle.environmentmapper' | translate}}</h4>
          </div>
          <!-- Modal body -->
          <div class="modal-body">
            <iframe width="100%" height="100%" class="youtubeVideo" id="EdVideoLink" frameborder="0"
              allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen>
            </iframe>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- The env delete confirm message modal -->
  <div class="modal fade" id="envDeleteConfirmModel" data-backdrop="">
    <div class="vertical-alignment-helper">
      <div class="modal-dialog vertical-align-center">
        <div class="modal-content">
          <!-- Modal body -->
          <div class="modal-body">
            <div class="row pb-0">
              <div class="col col-11 col-md-11 col-lg-11 col-sm-11 col-xs-11"></div>
              <div class="col col-1 col-md-1 col-lg-1 col-sm-1 col-xs-1 popupCloseBtn">
                <button type="button" class="close" data-dismiss="modal">&times;</button>
              </div>
              <div class="col col-12 col-md-12 col-lg-12 col-sm-12 col-xs-12">
                <div class="form-element text-align-center">
                  <label class="form-label marginbottom6px">{{'environmentDesigner.deleteenv' | translate}}</label>
                </div>
              </div>
            </div>
          </div>
          <!-- Modal footer -->
          <div class="modal-footer text-align-center">
            <button type="button" class="btn btn-secondary modalActionBtn marginright10per"
              (click)="deleteEnvironment()" data-dismiss="modal">
              {{'yes' | translate}}
            </button>
            <button type="button" class="btn btn-secondary modalActionBtn" data-dismiss="modal">
              {{'no' | translate}}</button>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- The env error message popup modal -->
  <div class="modal fade" id="environmentMsgPopup" data-backdrop="">
    <div class="vertical-alignment-helper">
      <div class="modal-dialog vertical-align-center">
        <div class="modal-content">
          <!-- Modal body -->
          <div class="modal-body">
            <div class="row pb-0">
              <div class="col col-11 col-md-11 col-lg-11 col-sm-11 col-xs-11"></div>
              <div class="col col-1 col-md-1 col-lg-1 col-sm-1 col-xs-1 popupCloseBtn">
                <button type="button" class="close" data-dismiss="modal">&times;</button>
              </div>
              <div class="col col-12 col-md-12 col-lg-12 col-sm-12 col-xs-12">
                <div class="form-element text-align-center">
                  <label class="form-label marginbottom6px">
                    {{toastMsgPopup}}
                  </label>
                </div>
              </div>
            </div>
          </div>
          <!-- Modal footer -->
          <div class="modal-footer text-align-center">
            <button type="button" class="btn btn-secondary modalActionBtn" data-dismiss="modal">
              {{ 'ok' | translate }}
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>